import { Component, OnInit, Input, Output, EventEmitter 
        ,OnChanges, SimpleChanges } from '@angular/core';
import { Chart } from 'chart.js';
import { Film } from 'models/film'
import { SelectedItem } from 'models/selectedItem';
import { SwapiService ,Type } from '../swapi.service';

@Component({
  selector: 'app-detial-view',
  templateUrl: './detial-view.component.html',
  styleUrls: ['./detial-view.component.css']
})
export class DetialViewComponent implements OnInit, OnChanges {
  @Input() selectedItem: SelectedItem;

  @Output() deselect : EventEmitter<boolean> = new EventEmitter<boolean>();
  myChart : Chart;

  constructor(private swapiService : SwapiService) { }

  ngOnInit() {
      var test = document.getElementById('profile')
      test.onclick = function(e){
          e.preventDefault();
          test.classList.add('active');
      }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.createDataView();

    //Remove old canvas element
    var ctx = document.getElementById('chart');
    ctx.remove();
    var contianer = document.getElementById('canvas-contianer');
    var newCtx = document.createElement('canvas');
    newCtx.id = 'chart';
    contianer.appendChild(newCtx);

    this.createChart();

    this.createRelatedDataView();

    //Make sure the view is visible
    if (window.innerWidth < 992)
        document.getElementById('detail').scrollIntoView({behavior: 'smooth'});
  }

  createDataView(){
    var dataContianer = document.getElementById('data');
    //Delete current data
    dataContianer.innerHTML = "";

    switch(this.selectedItem.type){
        case Type.film:
            dataContianer.appendChild(this.createHeading(this.selectedItem.item.title));
            dataContianer.appendChild(this.createInfoItem('Episode: ',this.selectedItem.item.episode_id));
            dataContianer.appendChild(this.createInfoItem('Opening Crawl: ',this.selectedItem.item.opening_crawl));
            dataContianer.appendChild(this.createInfoItem('Director: ',this.selectedItem.item.director));
            dataContianer.appendChild(this.createInfoItem('Producer(s): ',this.selectedItem.item.producer));
            dataContianer.appendChild(this.createInfoItem('Release Date: ',this.selectedItem.item.release_date));
            break;
        case Type.person:
            dataContianer.appendChild(this.createHeading(this.selectedItem.item.name));
            dataContianer.appendChild(this.createInfoItem('Birth year: ',this.selectedItem.item.birth_year));
            dataContianer.appendChild(this.createInfoItem('Eye Color: ',this.selectedItem.item.eye_color));
            dataContianer.appendChild(this.createInfoItem('Gender: ',this.selectedItem.item.gender));
            dataContianer.appendChild(this.createInfoItem('Hair Color: ',this.selectedItem.item.hair_color));
            dataContianer.appendChild(this.createInfoItem('Height(cm): ',this.selectedItem.item.height));
            dataContianer.appendChild(this.createInfoItem('Weight(kg): ',this.selectedItem.item.mass));
            dataContianer.appendChild(this.createInfoItem('Skin Color: ',this.selectedItem.item.skin_color));
            this.swapiService.getItem(this.selectedItem.item.homeworld).then(data => {
                dataContianer.appendChild(this.createInfoItem('Homeworld: ',data.name));
            });
            
            break;
        case Type.starship:
            dataContianer.appendChild(this.createHeading(this.selectedItem.item.name));
            dataContianer.appendChild(this.createInfoItem('Model: ',this.selectedItem.item.model));
            dataContianer.appendChild(this.createInfoItem('Starship class: ',this.selectedItem.item.starship_class));
            dataContianer.appendChild(this.createInfoItem('Manufacturer: ',this.selectedItem.item.manufacturer));
            dataContianer.appendChild(this.createInfoItem('Cost in galactic credits: ',this.selectedItem.item.cost_in_credits));
            dataContianer.appendChild(this.createInfoItem('Length(meters): ',this.selectedItem.item.length));
            dataContianer.appendChild(this.createInfoItem('Crew needed: ',this.selectedItem.item.crew));
            dataContianer.appendChild(this.createInfoItem('Passengers crew excluded: ',this.selectedItem.item.passengers));
            dataContianer.appendChild(this.createInfoItem('Max atmosphering speed: ',this.selectedItem.item.max_atmosphering_speed));
            dataContianer.appendChild(this.createInfoItem('Hyperdrive rating: ',this.selectedItem.item.hyperdrive_rating));
            dataContianer.appendChild(this.createInfoItem('Megalights per standart hour: ',this.selectedItem.item.MGLT));
            dataContianer.appendChild(this.createInfoItem('Capacity(kg): ',this.selectedItem.item.cargo_capacity));
            dataContianer.appendChild(this.createInfoItem('Maxium time the ship can provide consumables: ',this.selectedItem.item.consumables));
            break;
        case Type.vehicle:
            dataContianer.appendChild(this.createHeading(this.selectedItem.item.name));
            dataContianer.appendChild(this.createInfoItem('Model: ',this.selectedItem.item.model));
            dataContianer.appendChild(this.createInfoItem('Vehicle class: ',this.selectedItem.item.vehicle_class));
            dataContianer.appendChild(this.createInfoItem('Manufacturer: ',this.selectedItem.item.manufacturer));
            dataContianer.appendChild(this.createInfoItem('Cost in galactic credits: ',this.selectedItem.item.cost_in_credits));
            dataContianer.appendChild(this.createInfoItem('Length(meters): ',this.selectedItem.item.length));
            dataContianer.appendChild(this.createInfoItem('Crew needed: ',this.selectedItem.item.crew));
            dataContianer.appendChild(this.createInfoItem('Passengers crew excluded: ',this.selectedItem.item.passengers));
            dataContianer.appendChild(this.createInfoItem('Max atmosphering speed: ',this.selectedItem.item.max_atmosphering_speed));
            dataContianer.appendChild(this.createInfoItem('Capacity(kg): ',this.selectedItem.item.cargo_capacity));
            dataContianer.appendChild(this.createInfoItem('Maxium time the ship can provide consumables: ',this.selectedItem.item.consumables));
            break;
        case Type.species:
            dataContianer.appendChild(this.createHeading(this.selectedItem.item.name));
            dataContianer.appendChild(this.createInfoItem('Classification: ',this.selectedItem.item.classification));
            dataContianer.appendChild(this.createInfoItem('Designation: ',this.selectedItem.item.designation));
            dataContianer.appendChild(this.createInfoItem('Average height(cm): ',this.selectedItem.item.average_height));
            dataContianer.appendChild(this.createInfoItem('Average lifespan(years): ',this.selectedItem.item.average_lifespan));
            dataContianer.appendChild(this.createInfoItem('Eye colors: ',this.selectedItem.item.eye_colors));
            dataContianer.appendChild(this.createInfoItem('Hair colors: ',this.selectedItem.item.hair_colors));
            dataContianer.appendChild(this.createInfoItem('Skin colors: ',this.selectedItem.item.skin_colors));
            dataContianer.appendChild(this.createInfoItem('Language: ',this.selectedItem.item.language));
            this.swapiService.getItem(this.selectedItem.item.homeworld).then(data => {
                dataContianer.appendChild(this.createInfoItem('Homeworld: ',data.name));
            });
            break;
        case Type.planet:
            dataContianer.appendChild(this.createHeading(this.selectedItem.item.name));
            dataContianer.appendChild(this.createInfoItem('Diameter(km): ',this.selectedItem.item.diameter));
            dataContianer.appendChild(this.createInfoItem('Rotation period(hours): ',this.selectedItem.item.rotation_period));
            dataContianer.appendChild(this.createInfoItem('Orbital period(days): ',this.selectedItem.item.orbital_period));
            dataContianer.appendChild(this.createInfoItem('Gravity(standard G): ',this.selectedItem.item.gravity));
            dataContianer.appendChild(this.createInfoItem('Population: ',this.selectedItem.item.population));
            dataContianer.appendChild(this.createInfoItem('Climate: ',this.selectedItem.item.climate));
            dataContianer.appendChild(this.createInfoItem('Terrain: ',this.selectedItem.item.terrain));
            dataContianer.appendChild(this.createInfoItem('Surface water(percentage): ',this.selectedItem.item.surface_water));
            break;
    }

  }

  createRelatedDataView(){
    var related = document.getElementById('related-data');
    related.innerHTML = '';

    switch(this.selectedItem.type){
        case Type.film:
            this.appendSpecies();
            this.appendStarships();
            this.appendVehicles();
            this.appendCharacters();
            this.appendPlanets();
            break;
        case Type.person:
            this.appendFilms();
            this.appendSpecies();
            this.appendStarships();
            this.appendVehicles();
            break;
        case Type.starship:
        case Type.vehicle:
            this.appendFilms();
            this.appendPilots();
            break;
        case Type.species:
            this.appendPeople();
            this.appendFilms();
            break;
        case Type.planet:
            this.appendResidents();
            this.appendFilms();
            break;
    }

  }

  createRelatedContianer(headingText: string) : HTMLElement {
      var relatedContianer = document.createElement('div');
      relatedContianer.classList.add('related-contianer');
      var heading = this.createHeading(headingText);
      heading.classList.add('hoverable');
      heading.classList.add('bottom-border')
      relatedContianer.appendChild(heading);

      var listElement = document.createElement('ul');
      listElement.classList.add('related');
      listElement.classList.add('hidden');
      relatedContianer.appendChild(listElement);

      heading.onclick = function(){
          if (listElement.classList.contains('hidden'))
            listElement.classList.remove('hidden');
          else 
            listElement.classList.add('hidden');
      }
      
      var related = document.getElementById('related-data');
      related.appendChild(relatedContianer);

      return listElement;
  }

  createListElement() : HTMLElement {
    var li = document.createElement('li');
    li.classList.add('float');
    return li;
  }

  appendSpecies(){
      var listElement = this.createRelatedContianer('Species');
      
      this.selectedItem.item.species.forEach(element => {
          var li = this.createListElement();
          this.swapiService.getItem(element).then(data => {
              li.innerHTML = data.name;
              listElement.appendChild(li);
          })
      });
  }

  appendStarships(){
      
     var listElement = this.createRelatedContianer('Starships');
      
    this.selectedItem.item.starships.forEach(element => {
        var li = this.createListElement();
        this.swapiService.getItem(element).then(data => {
            li.innerHTML = data.name;
            listElement.appendChild(li);
        })
      });
  }

  appendVehicles(){
      var listElement = this.createRelatedContianer('Vehicles');
      
      this.selectedItem.item.vehicles.forEach(element => {
          var li = this.createListElement();
          this.swapiService.getItem(element).then(data => {
              li.innerHTML = data.name;
              listElement.appendChild(li);
          })
      });
  }

  appendCharacters(){
      var listElement = this.createRelatedContianer('Characters');

      this.selectedItem.item.characters.forEach(element => {
          var li = this.createListElement();
          this.swapiService.getItem(element).then(data => {
              li.innerHTML = data.name;
              listElement.appendChild(li);
          })
      });
  }

  appendPilots(){
      var listElement = this.createRelatedContianer('Pilots');
      
      this.selectedItem.item.pilots.forEach(element => {
          var li = this.createListElement();
          this.swapiService.getItem(element).then(data => {
              li.innerHTML = data.name;
              listElement.appendChild(li);
          })
      });
  }

  appendPeople(){
      var listElement = this.createRelatedContianer('People');
      
      this.selectedItem.item.people.forEach(element => {
          var li = this.createListElement();
          this.swapiService.getItem(element).then(data => {
              li.innerHTML = data.name;
              listElement.appendChild(li);
          })
      });
  }

  appendResidents(){
      var listElement = this.createRelatedContianer('Residents');
      
      this.selectedItem.item.residents.forEach(element => {
          var li = this.createListElement();
          this.swapiService.getItem(element).then(data => {
              li.innerHTML = data.name;
              listElement.appendChild(li);
          })
      });
  }

  appendPlanets(){
      var listElement = this.createRelatedContianer('Planets');
      
      this.selectedItem.item.planets.forEach(element => {
          var li = this.createListElement();
          this.swapiService.getItem(element).then(data => {
              li.innerHTML = data.name;
              listElement.appendChild(li);
          })
      });
  }

  appendFilms(){
      var listElement = this.createRelatedContianer('Films')
      
      this.selectedItem.item.films.forEach(element => {
          var li = this.createListElement();
          this.swapiService.getItem(element).then(data => {
              li.innerHTML = data.title;
              listElement.appendChild(li);
          })
      });
  }

  createHeading(value:string) : HTMLHeadingElement {
    var element = document.createElement('h4');
    element.innerHTML = value;
    return element;
  }

  createInfoItem(prefix:string, value:string) : HTMLHeadingElement {
    var element = document.createElement("h6");
    element.innerHTML = prefix + value;
    return element;
  }

  createChart(){
    var ctx = document.getElementById('chart');
    
    switch(this.selectedItem.type){
        case Type.film:
            this.myChart = this.createFilmChart(ctx);
            break;
        case Type.person:
            this.myChart = this.createPersonChart(ctx);
            break;
        case Type.starship:
        case Type.vehicle:
            this.myChart = this.createTransportChart(ctx);
            break;
        case Type.species:
            this.myChart = this.createSpeciesChart(ctx);
            break;
        case Type.planet:
            this.myChart = this.createPlanetChart(ctx);
            break;
    }

    ctx.onclick = this.chartClick;

    this.myChart.height = '100%';
    this.myChart.width = '100%';

  }

  chartClick(event){
    
  }

  createFilmChart(ctx : HTMLElement) : Chart {
    return new Chart(ctx, {
        type: 'bar',
        data: {
            labels: ["Species", "Characters", "Planets", "Vehicles", "Starships"],
            datasets: [{
                label: 'Number of',
                data: [this.selectedItem.item.species.length, this.selectedItem.item.characters.length, 
                        this.selectedItem.item.planets.length,
                      this.selectedItem.item.vehicles.length, this.selectedItem.item.starships.length],
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(255, 206, 86, 0.2)',
                    'rgba(75, 192, 192, 0.2)',
                    'rgba(153, 102, 255, 0.2)',
                ],
                borderColor: [
                    'rgba(255,99,132,1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                    'rgba(153, 102, 255, 1)',
                ],
                borderWidth: 1
            }]
        },
        options: {
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero:true
                    }
                }]
            }
        }
    });
  }

  createPersonChart(ctx:HTMLElement) : Chart {
    return new Chart(ctx, {
        type: 'bar',
        data: {
            labels: ["Films", "Species", "Vehicles", "Starships"],
            datasets: [{
                label: 'Number of',
                data: [this.selectedItem.item.films.length, this.selectedItem.item.species.length, 
                        this.selectedItem.item.vehicles.length,
                      this.selectedItem.item.starships.length],
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(255, 206, 86, 0.2)',
                    'rgba(75, 192, 192, 0.2)',
                ],
                borderColor: [
                    'rgba(255,99,132,1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                ],
                borderWidth: 1
            }]
        },
        options: {
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero:true
                    }
                }]
            }
        }
    });
  }

  createTransportChart(ctx:HTMLElement){
    return new Chart(ctx, {
        type: 'bar',
        data: {
            labels: ["Films", "Pilots"],
            datasets: [{
                label: 'Number of',
                data: [this.selectedItem.item.films.length, this.selectedItem.item.pilots.length],
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                ],
                borderColor: [
                    'rgba(255,99,132,1)',
                    'rgba(54, 162, 235, 1)',
                ],
                borderWidth: 1
            }]
        },
        options: {
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero:true
                    }
                }]
            }
        }
    });
  }

  createSpeciesChart(ctx:HTMLElement) : Chart{
    return new Chart(ctx, {
        type: 'bar',
        data: {
            labels: ["Films", "People"],
            datasets: [{
                label: 'Number of',
                data: [this.selectedItem.item.films.length, this.selectedItem.item.people.length],
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                ],
                borderColor: [
                    'rgba(255,99,132,1)',
                    'rgba(54, 162, 235, 1)',
                ],
                borderWidth: 1
            }]
        },
        options: {
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero:true
                    }
                }]
            }
        }
    });
  }

  createPlanetChart(ctx:HTMLElement) : Chart{
    return new Chart(ctx, {
        type: 'bar',
        data: {
            labels: ["Films", "Residents"],
            datasets: [{
                label: 'Number of',
                data: [this.selectedItem.item.films.length, this.selectedItem.item.residents.length],
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                ],
                borderColor: [
                    'rgba(255,99,132,1)',
                    'rgba(54, 162, 235, 1)',
                ],
                borderWidth: 1
            }]
        },
        options: {
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero:true
                    }
                }]
            }
        }
    });
  }
  
  deselectItem(){
    this.deselect.emit(false);
  }

}



// WEBPACK FOOTER //
// ./src/app/detial-view/detial-view.component.ts